<div style="height: 100%;" class="multipleOffersWrapper">
  <section id="main_logo" class="d-none d-xl-block d-md-block brandBlueBackground">
    <div class="container">
      <nav class="navbar navbar-expand-lg p-0">
        <div class="navbar-brand d-inline">
          <a routerLink="/dashboard">
            <img src="../../../assets/new-dash/logo/revenuedLogo.svg" class="img-fluid d-inline" alt="Revenued Logo" />
          </a>
        </div>
      </nav>
    </div>
  </section>

  <!-- <h1>{{calculatorMode}}</h1>
  <h1>{{isMerchantFlow}}</h1>
  <h1>{{offerAccepted}}</h1> -->
  <!-- <div style="background-color: #0040BA; height: 70px; width: 100%"></div>
  <div class="bluebackground1 bg-sub"></div>
  <div class="bluebackground"></div> -->

  <!-- <div class="brandBlueBackground bg-sub"></div> -->
  <!-- <div class="brandBlueBackground"></div> -->
  <div style="height: auto; padding-bottom: 0 !important;" class="commonBrandBg contentCard pricingCalcWrapper">

    <!-- ISO Commission Panel: visible only on ISO-facing pages (not merchant-facing) -->
    <aside class="isoCommissionPanel"
      *ngIf="isIsoCommissionEnabled && !isMerchantFacingMode && !offerAccepted && !noDrawComm && !loadingOffers && !showValidationError && offersListObj.length > 0">
      <div class="isoCommissionPanelInner">

        <!-- Up-Front Line Commission -->
        <div class="commissionSliderGroup">
          <label class="commissionLabel">
            Up-Front Line Commission
            <span class="sliderHint">(0.5% increments)</span>
          </label>
          <div class="commissionValueRow">
            <p class="commissionBigValue">{{ dealCommission }}%</p>
            <div class="commissionInputGroup">
              <input type="number" [(ngModel)]="dealCommission" step="0.5" min="0" [attr.max]="dealCommissionMax"
                (change)="recalculateWithCommissions()" class="commissionInput" />
              <span class="commissionInputSuffix">%</span>
            </div>
          </div>
          <div class="customSliderWrapper">
            <div class="sliderActiveZone" [style.width.%]="dealSliderWidthPct">
              <ngx-slider [(value)]="dealCommission" [options]="dealSliderOptions"
                (userChangeEnd)="recalculateWithCommissions()" class="commissionNgxSlider"
                [ngClass]="{'disabledSliderActive': dealSliderWidthPct < 100}"></ngx-slider>
            </div>
            <div class="commissionDeadZone" *ngIf="dealSliderWidthPct < 100"></div>
          </div>
        </div>

        <!-- Draw Commission — hidden when noDrawComm=true (ISO has disabled draw commission toggling for their reps) -->
        <div class="commissionSliderGroup">
          <label class="commissionLabel">
            Draw Commission
            <span class="sliderHint">(0.5% increments)</span>
          </label>
          <div class="commissionValueRow">
            <p class="commissionBigValue">{{ drawCommission }}%</p>
            <div class="commissionInputGroup">
              <input type="number" [(ngModel)]="drawCommission" step="0.5" min="0" [attr.max]="drawCommissionMax"
                (change)="recalculateWithCommissions()" class="commissionInput" />
              <span class="commissionInputSuffix">%</span>
            </div>
          </div>
          <div class="customSliderWrapper">
            <div class="sliderActiveZone" [style.width.%]="drawSliderWidthPct">
              <ngx-slider [(value)]="drawCommission" [options]="drawSliderOptions"
                (userChangeEnd)="recalculateWithCommissions()" class="commissionNgxSlider"
                [ngClass]="{'disabledSliderActive': drawSliderWidthPct < 100}"></ngx-slider>
            </div>
            <div class="commissionDeadZone" *ngIf="drawSliderWidthPct < 100"></div>
          </div>
        </div>

        <!-- Combined commission indicator -->
        <!-- <div class="commissionCombinedBadge"
          [class.commissionCombinedBadge--warning]="combinedCommission >= 8"
          [class.commissionCombinedBadge--limit]="combinedCommission >= 10">
          <span class="commissionCombinedLabel">Combined</span>
          <span class="commissionCombinedValue">{{ combinedCommission | number:'1.1-1' }}% / 10%</span>
        </div> -->

        <!-- Reset button: enabled only when sliders differ from offer defaults -->
        <button class="primary-general-btn  w-100 commissionResetBtn" [disabled]="!isCommissionModified"
          (click)="resetCommissions()">
          <ion-icon name="reload-outline"></ion-icon> Reset to Offer Defaults
        </button>

        <!-- Calculation Breakdown: live updates as sliders move. Hidden on production. -->
        <div class="calcBreakdownBox" *ngIf="isDevOrUatEnv && calculatedFactor > 0">
          <h6 class="calcBreakdownTitle">Calculation Breakdown</h6>

          <div class="calcBreakdownRow">
            <span class="calcBreakdownLabel">Up-Front Line Commission</span>
            <span class="calcBreakdownHint">pcntInitialLimit + upsellActivation</span>
            <span class="calcBreakdownValue">{{ dealCommission | number:'1.1-2' }}%</span>
          </div>

          <div class="calcBreakdownRow">
            <span class="calcBreakdownLabel">Draw Commission</span>
            <span class="calcBreakdownHint">pcntDraw + upsellDraw</span>
            <span class="calcBreakdownValue">{{ drawCommission | number:'1.1-2' }}%</span>
          </div>

          <div class="calcBreakdownRow">
            <span class="calcBreakdownLabel">Base Factor</span>
            <span class="calcBreakdownHint">from offer record</span>
            <span class="calcBreakdownValue">{{ currentBaseFactor | number:'1.2-4' }}</span>
          </div>

          <div class="calcBreakdownRow calcBreakdownTotal">
            <span class="calcBreakdownLabel">Calculated Sell Rate</span>
            <span class="calcBreakdownHint">baseFactor + (deal + draw) × upsellPts / 100</span>
            <span class="calcBreakdownValue">{{ calculatedFactor | number:'1.2-4' }}</span>
          </div>

          <!-- APR Inputs & Output section — only for NY/CA MCard -->
          <ng-container *ngIf="shouldShowEstAPR() && calculatedPeriodRate !== null">
            <div class="calcBreakdownTitle calcBreakdownSectionTitle">APR Inputs → financial.rate()</div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">freq</span>
              <span class="calcBreakdownHint">1 = daily, 5 = weekly</span>
              <span class="calcBreakdownValue">{{ aprInputFreq }}</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">nper</span>
              <span class="calcBreakdownHint">term ÷ freq</span>
              <span class="calcBreakdownValue">{{ aprInputNper | number:'1.0-2' }}</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">pmt</span>
              <span class="calcBreakdownHint">(drawAmount × factor) / nper</span>
              <span class="calcBreakdownValue">{{ aprInputPmt | number:'1.2-4' }}</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">pv</span>
              <span class="calcBreakdownHint">−drawAmount</span>
              <span class="calcBreakdownValue">{{ aprInputPv | number:'1.2-4' }}</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">fv</span>
              <span class="calcBreakdownHint">fully paid off at end</span>
              <span class="calcBreakdownValue">0</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">when</span>
              <span class="calcBreakdownHint">PaymentDueTime.End</span>
              <span class="calcBreakdownValue">0</span>
            </div>

            <div class="calcBreakdownRow">
              <span class="calcBreakdownLabel">guess</span>
              <span class="calcBreakdownHint">starting guess</span>
              <span class="calcBreakdownValue">0.1</span>
            </div>

            <div class="calcBreakdownRow calcBreakdownTotal">
              <span class="calcBreakdownLabel">Period Rate</span>
              <span class="calcBreakdownHint">rate(nper, pmt, pv, 0, 0, 0.1)</span>
              <span class="calcBreakdownValue">{{ calculatedPeriodRate | number:'1.4-6' }}</span>
            </div>

            <div class="calcBreakdownRow calcBreakdownTotal">
              <span class="calcBreakdownLabel">Nominal APR</span>
              <span class="calcBreakdownHint">periodRate × (260 / freq) × 100</span>
              <span class="calcBreakdownValue">{{ calculatedAPR | number:'1.2-2' }}%</span>
            </div>
          </ng-container>
        </div>

      </div>
    </aside>

    <div class="pricingCalcMainContent">
      <div id="wrapper">
        <div id="content">
          <div class="container p-0">
            <section id="ac_summary" class="d-flex justify-content-center "
              [ngClass]="{'floatingWindowActive': floatingWindowActive}">
              <div class="container d-md-block d-lg-block d-xl-block" *ngIf="!disableCalc">
                <div class="card card1">
                  <div *ngIf="!showValidationError" class="summaryHeadingWrapper">
                    <h1 class="summary-heading text-uppercase primaryPageHead">
                      <span fxFlex></span>Understand Your Pricing{{ busName ? ' - ' + busName : '' }}<span
                        fxFlex></span>
                    </h1>
                    <p *ngIf="offersListObj.length > 1" class="description primaryText50">
                      {{ getDescriptionText() }}
                    </p>
                  </div>

                  <!-- begin:: Design option 4 -->
                  <ng-container *ngIf="true">
                    <div class="offersGridParentWrapper4 mb-5">
                      <div class="loaderWrapper" *ngIf="loadingOffers">
                        <div class="loader">
                        </div>
                      </div>
                      <div class="validation-error-wrapper" *ngIf="showValidationError">
                        <div class="error-icon">
                          <mat-icon>error_outline</mat-icon>
                        </div>
                        <div class="validation-error-message">
                          <div class="error-content">
                            <!-- <h3 class="error-title">Access Error</h3> -->
                            <!-- <p class="error-description">{{ validationErrorMessage }}</p> -->
                            <p class="error-description" [innerHTML]="validationErrorMessage"></p>
                            <!-- <div class="contact-info">
                            <p>For assistance, please contact customer support at:</p>
                            <a href="tel:1-844-218-4834" class="contact-link">1-844-218-4834</a>
                            <p class="hours">(Monday - Friday, 8am - 7pm EST)</p>
                          </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="" *ngIf="!loadingOffers && !showValidationError && offersListObj.length === 0">
                        <div class="no-offers-message">
                          No offers found at this time, please contact customer service at
                          <a href="tel:1-844-218-4834" class="contact-link">1-844-218-4834</a> (M-F 8am - 7pm)
                        </div>
                      </div>
                      <div *ngIf="!loadingOffers && !showValidationError && offersListObj.length > 0">
                        <mat-tab-group mat-align-tabs="start" animationDuration="0ms"
                          (selectedTabChange)="onTabChanged($event);" [selectedIndex]="selectedOptionIndex">
                          <!-- <mat-tab [label]="item.labelName" *ngFor="let item of offersListObj, let i = index"> -->
                          <mat-tab *ngFor="let item of offersListObj, let i = index">
                            <ng-template mat-tab-label>
                              <figure class="tab-logo-figure" *ngIf="false">
                                <img [src]="item.favIcon" alt="Logo" class="tab-logo" />
                              </figure>
                              <span>{{ item.labelName }}</span>
                            </ng-template>

                            <div class="tabContentWrapper">
                              <div class="shadowWrapper">
                                <div class="offersGridWrapper">
                                  <ng-container *ngFor="let offerItem of offersListObj; let offerIndex = index">
                                    <div class="offerGridItem" [id]="'offerGridItem' + offerIndex"
                                      [ngClass]="{'selected': selectedOptionIndex === offerIndex, 'merchantOfferGridItem': isMerchantFlow}"
                                      (click)="onTabChanged({index: offerIndex})">
                                      <div
                                        [ngClass]="{'offerGridItemLayer': true, 'merchantOfferGridItem': isMerchantFlow}">
                                        <!-- {{ offerItem.labelName }} -->
                                        <div class="infoRow"
                                          (click)="calcAndScrollToSchedule(isMerchantFlow ? offerItem : item, (selectedOptionIndex), false, offerIndex)">
                                          <div class="padBox">
                                            <figure class="padbox-logo-figure">
                                              <img
                                                [src]="selectedOptionIndex === offerIndex ? offerItem.logoUrl : offerItem.logoUrlDark"
                                                alt="Logo" class="padbox-logo" />
                                            </figure>
                                            <div class="groupItem" *ngIf="offerItem?.limit">
                                              <h2 class="title">
                                                <!-- Available Spending Limit -->
                                                {{ offerIndex === 3 ? 'Offer Amount' : getAvailableSpendingLimitText()
                                                }}
                                              </h2>
                                              <p class="description">
                                                {{ offerItem?.limit | currency }}
                                              </p>
                                              <div class="importantLimitNoteWrapper" *ngIf="showImportantNote">
                                                <div class="importantLimitNoteContent"
                                                  *ngIf="offerItem?.limit >= 150000">
                                                  <mat-icon>info</mat-icon>
                                                  <p class="importantLimitNote">
                                                    Accepting this offer may require additional
                                                    financials
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                            <div *ngIf="shouldShowEstAPR()" class="groupItem">
                                              <h2 class="title">
                                                {{ getEstdAPRText() }}
                                              </h2>
                                              <p class="description">
                                                {{isLoanProductMode ? '$' : ''}}
                                                {{ offerItem?.estAPR ? offerItem?.estAPR : 'NA' }}
                                              </p>
                                            </div>

                                            <div *ngIf="!offerAccepted && !isMerchantFlow" class="groupItem">
                                              <h2 class="title">
                                                {{ getFactorText() }}
                                              </h2>
                                              <p class="description">
                                                {{(isLoanProductMode || shouldShowEstAPR()) ? '$' : ''}}{{ offerItem?.factor?.toFixed?.(2) }}
                                              </p>
                                            </div>

                                            <div class="groupItem">
                                              <h2 class="title">
                                                {{ offerIndex === 3 ? "Payback Period"
                                                : getPaybackPeriodText()}}
                                                <span *ngIf="shouldShowPaybackPeriodTooltip" class="pricingTooltip"
                                                  mat-raised-button #tooltip="matTooltip"
                                                  matTooltip="Why your term is 'Estimated.' We based your payments on a percentage of your estimated sales revenue. Because we cannot predict the exact dollar amount of sales revenue your business will collect in the future, your term is 'Estimated.'"
                                                  aria-label="Button that displays a tooltip when focused or hovered over"
                                                  matTooltipHideDelay="0"
                                                  (click)="$event.stopPropagation(); showTemporaryTooltip(tooltip);">
                                                  <mat-icon>info</mat-icon>
                                                </span>

                                              </h2>
                                              <p class="description">
                                                {{ offerItem?.term }} {{ isLoanProductMode ? 'Business Days' : '' }}
                                              </p>
                                            </div>

                                            <div class="groupItem">
                                              <h2 class="title">
                                                {{ offerIndex === 3 ? (selectedOption | titlecase) + ' Payment' :
                                                getDailyPaymentText() }}
                                              </h2>
                                              <p class="description" *ngIf="selectedOption === 'daily'">
                                                {{ offerItem?.dailyPayment | currency }}
                                              </p>
                                              <p class="description" *ngIf="selectedOption === 'weekly'">
                                                {{ (offerItem?.dailyPayment * 5) | currency }}
                                              </p>
                                            </div>

                                          </div>
                                        </div>

                                        <!-- <div class="infoRow actionBtnWrapper" *ngIf="selectedOptionIndex== offerIndex">
                                      <button type="button" class="actionBtn" *ngIf="false"
                                        (click)="calcAndScrollToSchedule(item, (selectedOptionIndex))">
                                        See Schedule
                                      </button>
                                      <button type="button" class="actionBtn acceptBtn"
                                        (click)="openConfirmationDialog(item, (i))">
                                        Accept Offer
                                      </button>
                                    </div> -->
                                      </div>
                                    </div>

                                  </ng-container>

                                </div>
                              </div>

                              <div class="infoRow actionBtnWrapper"
                                [ngClass]="selectedOptionIndex === i ? 'selectedOption' + (i + 1) : ''">
                                <button type="button" class="actionBtn" *ngIf="false"
                                  (click)="calcAndScrollToSchedule(item, (i))">
                                  See Schedule
                                </button>
                                <button *ngIf="!offerAccepted && !isMerchantFlow" type="button"
                                  class="actionBtn acceptBtn" (click)="openConfirmationDialog(item, (i))">
                                  Accept Offer - {{ item?.labelName }}
                                </button>
                              </div>
                            </div>






                            <div style="padding-left: 10px; margin-top: 30px;" *ngIf="selectedOptionIndex !== 3">
                              <p>{{ transformDrawToLoan('Enter different draw amounts to see how your estimated ' +
                                selectedOption + ' payment changes and also how you can save money by paying off
                                earlier.') }}</p>
                            </div>
                            <div id="capture-pricing-cal-schedule" *ngIf="selectedOptionIndex !== 3">
                              <div
                                style="display: flex; padding: 0 20px 20px; padding-left: 10px; justify-content:space-between;"
                                class="inputs-container">

                                <div class="formFieldsRow">
                                  <div class="form-inline input-gutter-cal">
                                    <label for="amount-input" class="m-0 formatText"
                                      style="text-transform:inherit !important;padding-right: 10px;">
                                      {{ getDrawAmountText() }}</label>
                                    <span class="input-symbol-dollar">
                                      <input appNumbersOnly id="amount-input" name="amount" [(ngModel)]="amount"
                                        [attr.max]="item?.limit" (ngModelChange)="sanitizeAmount()"
                                        (keyup)="reCalcOfferDailyPayments()"
                                        (blur)="enforceMinOnBlur()"
                                        class="form-control amount-input"
                                        [placeholder]="getDrawAmountText()" [attr.aria-label]="getDrawAmountText()"
                                        [attr.title]="getDrawAmountText()" /></span>
                                  </div>
                                  <div class="form-inline input-gutter-cal">
                                    <h6 class="m-0 formatText"
                                      style="text-transform:inherit !important;padding-right: 10px;">
                                      Start Date</h6>
                                    <mat-form-field appearance="outline" class="myMatFormField"
                                      subscriptSizing="dynamic">
                                      <!-- <mat-label>Select Start Date</mat-label> -->
                                      <input matInput [matDatepicker]="startDate" placeholder="Start Date"
                                        name="Start Date" aria-label="Please enter Start Date."
                                        [(ngModel)]="selectedDate" [nzDisabledDate]="disablePastDates"
                                        (ngModelChange)="reCalcOfferDailyPayments()">
                                      <mat-datepicker-toggle matSuffix [for]="startDate">
                                        <img src="../../../assets/new-dash/Calender-icon.svg" class="iconBox"
                                          alt="Calender Icon" />
                                      </mat-datepicker-toggle>
                                      <mat-datepicker #startDate></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div *ngIf="!offerAccepted && !isMerchantFlow"
                                  class="screenshotWrapper capture-pricing-cal-schedule-exclude"
                                  [ngClass]="{ 'disable-capture-pricing': !showScheduleTable }"
                                  [title]="!showScheduleTable ? 'Screenshot is enabled only when viewing the schedule.' : ''"
                                  (click)="showScheduleTable && captureScreenshot()">
                                  <figure class="screenshotImg">
                                    <img src="../../../assets/new-dash/icons/screenshot.svg" alt="Take a screenshot">
                                  </figure>
                                  <p class="screenshotTitle text-center">
                                    Screenshot
                                  </p>
                                </div>

                              </div>
                              <div
                                class="sliderContainer priceSliderContainer d-none capture-pricing-cal-schedule-exclude">
                                <ngx-slider [value]="amount" (valueChange)="onAmountSliderValueChange($event)"
                                  (userChangeEnd)="reCalcOfferDailyPayments()" [options]="sliderOptions"
                                  class="priceSlider"></ngx-slider>
                                <span class="default-slider-tick" (click)="defaultValue = 100"></span>
                              </div>
                              <div>
                                <div *ngIf="showScheduleTable" style="display: flex;" class="big-figures">
                                  <div class="prepay-cal-daily-tag" [ngClass]="selectedOptionClass">
                                    <h1 class="font-light text-white m-0" *ngIf="selectedOption === 'daily'">{{
                                      dailyPayment | currency }}</h1>
                                    <h1 class="font-light text-white m-0" *ngIf="selectedOption === 'weekly'">{{
                                      weeklyPayment | currency }}</h1>
                                    <h6 class="text-white m-0" *ngIf="selectedOption === 'daily'">{{
                                      getDailyPaymentText()
                                      }}
                                    </h6>
                                    <h6 class="text-white m-0" *ngIf="selectedOption === 'weekly'">{{
                                      getDailyPaymentText() }}</h6>
                                    <p class="text-white m-0" style="font-size: 12px;">(Based on Selected {{
                                      getDrawAmountText()?.replace(' ($)', '')}})</p>
                                  </div>
                                  <div class="prepay-cal-total-pay-tag" [ngClass]="selectedOptionClass">
                                    <h1 class="font-light text-white m-0">{{ startingBalance | currency }}</h1>
                                    <h6 class="text-white m-0">{{ getPurchaseAmountText() }}</h6>
                                    <p class="text-white m-0" style="font-size: 12px;">{{ transformDrawToLoan('(Based on
                                      Selected Draw Amount)') }}</p>
                                  </div>
                                  <div *ngIf="!shouldHideSpecifiedPercentage" class="prepay-cal-total-pay-tag"
                                    [ngClass]="selectedOptionClass">
                                    <h1 class="font-light text-white m-0">{{ specifiedPercentage | number:'1.2-2' }}%
                                    </h1>
                                    <h6 class="text-white m-0">Specified Percentage</h6>
                                    <p class="text-white m-0" style="font-size: 12px;">(Based on Daily Est. Receipts of
                                      {{
                                      (avgDailyRev/ 21.6667) | currency }})</p>
                                  </div>
                                </div>
                                <div>
                                  <p style="padding: 8px; margin-top: 12px; font-size: 80%; font-style: italic;"
                                    *ngIf="!isLoanProductMode">
                                    <b>Note:</b> The tool below is for illustrative purposes only and does not
                                    demonstrate
                                    a commitment from either party. Merchant may at its option use the <a
                                      href="{{getPayNowUrl()}}">Program Website</a> to offer to pay the remaining
                                    balance
                                    of the Purchased Amounts to {{isLoanProductMode ? "Revenued VA" : "Revenued"}} on an
                                    accelerated basis in a discounted amount,
                                    which {{isLoanProductMode ? "Revenued VA" : "Revenued"}} in its sole discretion may
                                    accept or reject.
                                  </p>
                                  <p style="padding: 8px; margin-top: 12px; font-size: 80%; font-style: italic;"
                                    *ngIf="isLoanProductMode">
                                    <b>Note:</b> The tool below is for illustrative purposes only and does not
                                    demonstrate
                                    a commitment from either party. Merchant may, at its option, use the <a
                                      href="{{getPayNowUrl()}}">Program Website</a> to offer to pay the remaining
                                    balance
                                    of the Purchased Amounts to {{isLoanProductMode ? "Revenued VA" : "Revenued"}} on an
                                    accelerated basis in a discounted
                                    amount, which {{isLoanProductMode ? "Revenued VA" : "Revenued"}} in its sole
                                    discretion may accept or reject.
                                  </p>
                                </div>
                                <br />
                                <div #scheduleTable [ngClass]="selectedOptionClass" class="scheduleListTable">
                                  <!-- <div class="optionTitleWrapper capture-pricing-cal-schedule-exclude" *ngIf="showScheduleTable">
                            <h3 class="title">
                              Schedule for
                              <label for="priceOptions">:</label>
                              <select name="pricingOptions" id="priceOptions" class="pricingOptionsList"
                                [(ngModel)]="selectedOptionIndex" (change)="onOptionChange($event)">
                                <option *ngFor="let offer of offersListObj; let i = index;" [value]="i">{{ "Option " +
                                  (i+1)
                                  }}</option>
                              </select>
                            </h3>
                          </div> -->
                                  <nz-table *ngIf="showScheduleTable" class="prepay-cal" #basicTable
                                    [nzData]="payNowRows" [nzHideOnSinglePage]="true"
                                    nzNoResult="Please provide both the {{getDrawAmountText()}} and start date to see the payment schedule.">
                                    <thead>
                                      <tr>
                                        <th><span nz-tooltip nzTooltipTitle=""># of
                                            Periods</span></th>
                                        <th><span nz-tooltip nzTooltipTitle="">Date</span></th>
                                        <th><span nz-tooltip nzTooltipTitle="">Sum of
                                            Payments</span></th>
                                        <th><span nz-tooltip nzTooltipTitle="">Remaining
                                            Balance</span></th>
                                        <th><span nz-tooltip nzTooltipTitle="">PayNow
                                            Balance</span></th>
                                        <th><span nz-tooltip nzTooltipTitle="">Total Paid</span>
                                        </th>
                                        <th><span nz-tooltip nzTooltipTitle="">{{ getTotalCostCapitalText() }}</span>
                                        </th>
                                        <th><span nz-tooltip nzTooltipTitle="">Total
                                            Savings</span></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let data of basicTable.data" class="prepay-cal-row">
                                        <td>{{ selectedOption === 'daily' ? data.days: data.days/5 }}</td>
                                        <td>{{data.date | date}}</td>
                                        <td>{{data.sumOfDallies | currency }}</td>
                                        <td>{{data.remainingBalance | currency }}</td>
                                        <td>{{data.payNowBalance | currency}}</td>
                                        <td>{{data.totalPaid | currency}}</td>
                                        <td>{{data.totalCostCapital | currency}}</td>
                                        <td>{{data.totalSavings | currency}}</td>
                                      </tr>
                                    </tbody>
                                  </nz-table>
                                  <nz-table *ngIf="showScheduleTable" class="mob-prepay-cal" #mobilePricingTable
                                    [nzData]="payNowRows" [nzHideOnSinglePage]="true"
                                    nzNoResult="Please provide both the {{getDrawAmountText()}} and start date to see the payment schedule.">
                                    <thead>

                                      <tr>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle=""># of
                                            Periods</span></th>
                                        <th nzWidth="130px"><span nz-tooltip nzTooltipTitle="">Date</span></th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">Sum of
                                            Payments</span></th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">Remaining
                                            Balance</span></th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">PayNow
                                            Balance</span></th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">Total Paid</span>
                                        </th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">{{ getTotalCostCapitalText()
                                            }}</span></th>
                                        <th nzWidth=""><span nz-tooltip nzTooltipTitle="">Total
                                            Savings</span></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let data of mobilePricingTable.data" class="prepay-cal-row">
                                        <td>{{ selectedOption === 'daily' ? data.days: data.days/5 }}</td>
                                        <td>{{data.date | date}}</td>
                                        <td>{{data.sumOfDallies | currency }}</td>
                                        <td>{{data.remainingBalance | currency }}</td>
                                        <td>{{data.payNowBalance | currency}}</td>
                                        <td>{{data.totalPaid | currency}}</td>
                                        <td>{{data.totalCostCapital | currency}}</td>
                                        <td>{{data.totalSavings | currency}}</td>
                                      </tr>
                                    </tbody>
                                  </nz-table>
                                </div>
                              </div>
                            </div>

                          </mat-tab>
                        </mat-tab-group>
                      </div>
                    </div>

                  </ng-container>
                  <!-- end:: Design option 4 -->






                </div>
              </div>
              <div class="container d-md-block d-lg-block d-xl-block" *ngIf="disableCalc">
                <div class="card card1">
                  <div class="summaryHeadingWrapper">
                    <h1 class="summary-heading primaryPageHead" *ngIf="!isMerchantFlow">
                      <span fxFlex></span> This tool is currently unavailable. Please contact customer service<span
                        fxFlex></span>
                    </h1>
                    <h1 class="summary-heading primaryPageHead" style="font-size: 18px;" *ngIf="isMerchantFlow">
                      <span fxFlex></span>To learn more about your financing from Revenued, please visit the <a
                        href="{{getUnderstandYourPricingUrl()}}">Understand Your Pricing</a> page in your account.<span
                        fxFlex></span>
                    </h1>
                  </div>
                </div>
              </div>
            </section>

            <section class="floatingWindow" *ngIf="floatingWindowActive">
              <div class="contentWrapper">
                <h3 class="title">
                  Merchant Friendly Link
                </h3>
                <div class="contentWrapperRow">
                  <p class="linkText">
                    {{getMerchantFriendlyLink()}}
                  </p>
                  <ion-button class="primary-general-btn" mat-ripple (click)="copyLinkToClipboard()">
                    {{copyButtonText}} <mat-icon>content_copy</mat-icon>
                  </ion-button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div><!-- /pricingCalcMainContent -->
  </div>
  <section id="footer">
    <app-footer noAuth="true"></app-footer>
  </section>
  <div class="md-hide splash-screen">
    <h4 style="color: #fff; font-weight: 300;">For a better experience</h4>
    <h2 style="color: #fff;">Please switch to portrait orientation.</h2>
  </div>
</div>
